import SubcontractorHolidayPaymentsCreate from "./SubcontractorHolidayPaymentsCreate";
import SubcontractorHolidayPaymentsEdit from "./SubcontractorHolidayPaymentsEdit";

export default {
  name: "subcontractorHolidayPayments",
  create: SubcontractorHolidayPaymentsCreate,
  edit: SubcontractorHolidayPaymentsEdit,
};
